import { useQuery } from "@tanstack/react-query";
import adminApiClient, { AffiliatePayment } from "../../api/admin";
import { PaymentsRange } from "../../views/Dashboard/components/PaymentsRangeFilter";

const useAffiliatePayments = (range: PaymentsRange) => {
  return useQuery<AffiliatePayment[]>({
    queryKey: ["affiliatePayments", range],
    queryFn: () => adminApiClient.getAffiliatePayments(range),
  });
};

export default useAffiliatePayments;
